angular.module('SpidApp')

.factory('SaleSyncService',
        ['$http', 'SyncConfig', 'Chunker', '$q',
function ($http,   SyncConfig,   Chunker,   $q) {
  var nodeUrl = SyncConfig.Node.getURLFor('/sales')
  var nodePushUrl = SyncConfig.Node.getURLFor('/synchro/sales')
  var nodeAuthorization = SyncConfig.Node.Authorization
  
  var distantUrl = SyncConfig.Distant.getURLFor('/sales')
  var distantAuthorization = SyncConfig.Distant.Authorization

  var SaleSyncService = {
    Node: {
      getAllUnsync: function (lastSyncIsoDate) {
        if (!lastSyncIsoDate) {
          throw 'SaleSyncService::Node::getAllUnsync() - Missing parameters'
        }

        var req = { method: 'GET', url: nodeUrl, headers: { 'Authorization': nodeAuthorization } }
        
        return $http(req).then(function (response) {
          return response.data
        }).then(function (sales) {
          var res = _.filter(sales, function (sale) {
            return moment(sale.updated_at).isAfter(moment(lastSyncIsoDate), 'second')
          })
          return res
        })
      },

      pushAll: function (elems) {
        // var chunked = Chunker.inConstantSizeChunks(elems, SyncConfig.config.chunkLength)
        var chunked = Chunker.inConstantSizeChunks(elems, 100)
        var p = $q(function (r) {r()})
        
        var pools = []
        for(var i = 0 ; i < chunked.length ; i++) {
          var data = chunked[i]
          var req = { method: 'POST', url: nodePushUrl, headers: { 'Authorization': nodeAuthorization }, data: data }
          pools.push($http(req))
        }
        
        return p.then(function () {
          return $q.all(pools)
        }).then(function () {
          return {sales: 'OK'}
        })
      }
    },
    Distant: {
      getAllUnsync: function () {
        var req = { method: 'GET', url: distantUrl, headers: { 'Authorization': distantAuthorization } }

        return $http(req).then(function (response) {
          return response.data
        })
      },

      pushAll: function (elems) {
          var chunked = Chunker.inConstantSizeChunks(elems, SyncConfig.config.chunkLength)
          var p = $q(function (r) {r()})

          var pool = []
          for(var i = 0 ; i < chunked.length ; i++) {
              var data = chunked[i]
              var req = { method: 'POST', url: distantUrl, headers: { 'Authorization': distantAuthorization }, data: data }
              pool.push($http(req))
          }

          return p.then(function () {
              return $q.all(pool)
          }).then(function () {
              return {generic: 'OK'}
          })
      }
    }
  }

  return SaleSyncService
}])